import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ProService } from '../db/models/pro-services';
import { SearchData } from '../db/models/search';
import { SearchResult } from '../db/models/search-result';
import { ServiceView } from '../db/models/service-view';
import { User } from '../db/models/user';
import { AuthenticationService } from '../services/authentication.service';
import { ProfessionalServiceService } from '../services/professional-service.service';
import { SearchService } from '../services/search.service';
import { ViewsService } from '../services/views.service';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent implements OnInit {

  // _services: ProService[];
  searchData: SearchData;
  searchResults: SearchResult[];
  currentUser: User;


  view = new ServiceView()

  constructor(private router: Router,
          private service: SearchService,
          private authenticate: AuthenticationService,
          private vservice: ViewsService,
          private notify: ToastrService,
          private spinner: NgxSpinnerService)
          {
            this.getSearchParams();

            this.getAllServices(this.searchData);
            this.authenticate.currentUser.subscribe(x => this.currentUser = x);
          }

  ngOnInit() {
    // this.getSearchParams();

    // this.getAllServices();
  }

  getSearchParams() {
   this.searchData = this.service.SearchParams;
   console.log(this.searchData);
  }

  registerRequest(data) {
    // console.log('You clicked me', data);
    this.view.serviceId = data.id;
    if(this.currentUser){
      this.view.userId = this.currentUser.id;
    }
    console.log(this.view);
    this.vservice.RegisterServiceView(this.view)
      .subscribe({
        next: () => {
          this.notify.info('Successful View');
        },
        error: err => {
          this.notify.warning('View Unsuccesfull');
        }
      })

  }

  getAllServices(data:SearchData) {
    this.service.getSearchResults(data).subscribe(
      res => {
        this.searchResults = res;
        console.log(this.searchResults)
      },
      error => {
        // this.spinner.hide();
        // this.errorNotification();
      }
    )

  }

  // saveData(){
  //   console.log('New Service', this.pro_service);
  //     if (this.pro_service.id == null) {
  //       this.service.createProfessionalService(this.pro_service)
  //       .subscribe({
  //         next: () => {
  //           this.spinner.hide();
  //           this.successNotification();

  //         },
  //         error: err => {
  //           this.spinner.hide();
  //           this.errorNotification();

  //         }
  //       })
  //     }
  //   }


}
